import { useDispatch } from "react-redux";
import {setLoader, setNotifications, setUnreadNotifications} from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";
import {
    useLazyGetNotificationQuery,
    useLazyGetUnreadNotificationQuery,
    useLazyMarkNotificationQuery
} from "../../../Store/Builder/techsbook.api";

const useGetNotificationsApi = () => {
  const dispatch = useDispatch();
  const [getNotifications] = useLazyGetNotificationQuery();
  const [getUnreadNotifications] = useLazyGetUnreadNotificationQuery();
  const [markNotification] = useLazyMarkNotificationQuery();
  const get = (params) => {
    dispatch(setLoader(true));
    getNotifications(params)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(setNotifications(res));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error account", "error");
      });

    getUnreadNotifications(params)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(setUnreadNotifications(res));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error account", "error");
      });
  };

  const mark = (data) => {
    dispatch(setLoader(true));
    markNotification(data)
      .unwrap()
      .then(
        () => {}
      )
      .then((res) => {
        dispatch(setLoader(false));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data[0] ?? "Error", "error");
      });
  };

  return {
    get,
    mark
  };
};

export default useGetNotificationsApi;
